import AMP from './amp';
import {
  isAPIErrorResponse,
  APIErrorResponse
} from '@arc-publishing/sdk-subs-core/lib/utils/APIErrorResponse';

import { logPrefix } from './constants';

/**
 * @param readerId READER_ID from Amp
 *
 * If readerId is passed, checks storage to ensure readerId is stored. If no readerId is passed,
 * checks storage for existing id. If user is logged in, checks to ensure passed readerId or
 * existing storage id is saved for that user in Sales. Options should contain injectable Identity,
 * identityAPIOrigin and salesAPIOrigin.
 *
 */
export default async function checkAMPReaderID(
  readerId?: string | undefined
): Promise<string | APIErrorResponse> {
  if (typeof window === 'undefined') {
    return '';
  }
  if (!AMP._Identity) {
    const error = `${logPrefix} no Identity provided in AMP.options`;
    console.error(error);
    throw new Error(error);
  }
  const existingReaderId = AMP.ampReaderId;
  const isLoggedIn = await AMP._Identity.isLoggedIn();
  let ampReaderId = readerId || '';

  if (ampReaderId && (!existingReaderId || existingReaderId !== ampReaderId)) {
    AMP.ampReaderId = ampReaderId;
  }

  if (AMP.ampReaderId) {
    ampReaderId = AMP.ampReaderId;
  }

  if (isLoggedIn) {
    let allUserReaderIds: Array<string> = [];
    const ids = await AMP.getAMPReaderIDs();
    if (Array.isArray(ids)) {
      allUserReaderIds = ids;
    }

    if (ampReaderId && !allUserReaderIds.includes(ampReaderId)) {
      const resp = await AMP.saveAMPReaderID(ampReaderId);
      if (isAPIErrorResponse(resp)) {
        throw resp;
      }
    }
  }
  return ampReaderId;
}
